module.exports = __webpack_public_path__ + "img/paypal.a03d6ffb.png";